import { tv } from "tailwind-variants";
const badgeVariant = tv({
  base: "inline-flex items-center justify-center rounded-full py-3 px-3 h-8 text-s3 font-medium focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  variants: {
    colorPalette: {
      goldGradient: "bg-gradient-golden text-foreground",
      blue: "bg-blue-600 text-white",
      green: "bg-green-600 text-white",
      mauveGradient: "bg-gradient-secondary text-foreground",
      warningGradient: "bg-gradient-warning text-foreground",
      darkGrey: "bg-slate-400 text-white",
      darkerGrey: "bg-slate-600 text-white",
      lightGrey: "bg-slate-100 text-slate-600",
      greenGradient: "bg-gradient-main text-white",
      lightBlueGradient: "bg-gradient-light-blue",
      lightBlueGreenGradient: "bg-gradient-light-blue-green"
    },
    status: {
      active: "",
      rejected: "",
      inactive: "",
      pending: ""
    },
    mode: {
      vibrant: "",
      light: ""
    },
    hasPrefix: {
      true: "pl-2"
    },
    hasSuffix: {
      true: "pr-2"
    }
  },
  compoundVariants: [
    { status: "active", mode: "vibrant", class: "bg-green-500 text-white" },
    { status: "active", mode: "light", class: "bg-green-100 text-foreground" },
    { status: "rejected", mode: "vibrant", class: "bg-red-500 text-white" },
    { status: "rejected", mode: "light", class: "bg-red-100 text-foreground" },
    { status: "inactive", mode: "vibrant", class: "bg-slate-500 text-white" },
    {
      status: "inactive",
      mode: "light",
      class: "bg-slate-100 text-foreground"
    },
    {
      status: "pending",
      mode: "vibrant",
      class: "bg-orange-500 text-foreground"
    },
    {
      status: "pending",
      mode: "light",
      class: "bg-orange-100 text-foreground"
    }
  ],
  defaultVariants: {
    colorPalette: "greenGradient",
    mode: "vibrant"
  }
});
export {
  badgeVariant
};
